import api from '@/services/api/ugc'
import * as types from '@/store/mutation-types'
import { handleError, buildSuccess } from '@/utils/utils.js'

const getters = {}
const mutations = {}
const state = {}

const actions = {
    

async updateUgcVideo({ commit }, payload) {
  commit(types.SHOW_CENTER_LOADING, true)

  try {
    const response = await api.updateUgcVideo(payload)
    const ok = [200].includes(response?.status)

    if (!ok) throw new Error(`unexpected status ${response?.status}`)

    // se quiser só feedback visual:
    buildSuccess({ msg: 'common.SAVED_SUCCESSFULLY' }, commit)

    // se precisar dos dados:
    return response?.data
  } catch (err) {
    handleError(err, commit)
    throw err
  } finally {
    commit(types.SHOW_CENTER_LOADING, false)
  }
},

async updateUgcVideoSilent(_, payload) {
  const response = await api.updateUgcVideo(payload)
  const ok = [200].includes(response?.status)

  if (!ok) throw new Error(`unexpected status ${response?.status}`)

  return response?.data
},

async postGiftVideo({ commit }, payload) {
  commit(types.SHOW_CENTER_LOADING, true)

  try {
    const response = await api.postGiftVideo(payload)
    const ok = [200].includes(response?.status)

    if (!ok) throw new Error(`unexpected status ${response?.status}`)

    buildSuccess({ msg: 'common.SAVED_SUCCESSFULLY' }, commit)

    return response?.data
  } catch (err) {
    handleError(err, commit)
    throw err
  } finally {
    commit(types.SHOW_CENTER_LOADING, false)
  }
},

async deleteGiftVideo({ commit }, payload) {
  commit(types.SHOW_CENTER_LOADING, true)

  try {
    const response = await api.deleteGiftVideo(payload)
    const ok = [200, 204].includes(response?.status)

    if (!ok) throw new Error(`unexpected status ${response?.status}`)

    buildSuccess({ msg: 'common.SAVED_SUCCESSFULLY' }, commit)

    return response?.data
  } catch (err) {
    handleError(err, commit)
    throw err
  } finally {
    commit(types.SHOW_CENTER_LOADING, false)
  }
},

  async fetchUgcVideos({ commit }, payload) {
    commit(types.SHOW_CENTER_LOADING, true)

    try {
      const response = await api.getVideos(payload)
      if (response.status === 200) return response.data.docs

      throw new Error(`Status inesperado: ${response.status}`)
    } catch (error) {
      handleError(error, commit, () => {})
    } finally {
      commit(types.SHOW_CENTER_LOADING, false)
    }
  },

  // aliases opcionais, caso você ainda queira nomes específicos
  getUgcVideos({ dispatch }) {
    return dispatch('fetchUgcVideos')
  },
  getEventUgcVideo({ dispatch }, payload) {
    return dispatch('fetchUgcVideos', payload)
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
